export default __webpack_public_path__ + "static/media/load.7687bcc5.gif";